export default __webpack_public_path__ + "static/media/dark_close.adbdaa08.svg";